import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "k-count-to" }
const _hoisted_2 = { class: "k-count-to__outer" }
const _hoisted_3 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "left"),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", {
        class: _normalizeClass(['k-count-to__text', _ctx.countClass]),
        id: _ctx.counterId
      }, _toDisplayString(_ctx.init), 11, _hoisted_3),
      _createElementVNode("i", {
        class: _normalizeClass(['k-count-to__unit—text', _ctx.unitClass])
      }, _toDisplayString(_ctx.unitText), 3)
    ]),
    _renderSlot(_ctx.$slots, "right")
  ]))
}